export { default } from './Lock'
